import { type Theme, useTheme } from '@mui/material'
import { useMemo } from 'react'
import type { ThemeColorEntry } from '../types.js'

export function useParseTheme() {
  const { palette } = useTheme()

  return useMemo(() => flattenPalette(palette), [palette])
}

// component specific colors that are generated based on other tokens
const excludeEntries = [
  'Alert',
  'FilledInput',
  'LinearProgress',
  'Slider',
  'SnackbarContent',
  'SpeedDialAction',
  'Switch',
  'TableCell',
  'Tooltip',
]

function flattenPalette(palette: Theme['palette'], parentKey = ''): ThemeColorEntry[] {
  return Object.entries(palette).reduce<ThemeColorEntry[]>((acc, [key, value]) => {
    if (excludeEntries.includes(key)) {
      return acc
    }

    const path = parentKey === '' ? key : `${parentKey}.${key}`

    if (typeof value === 'object') {
      const children = flattenPalette(value, path)
      acc.push(...children)
      return acc
    }

    if (typeof value !== 'string' || value.includes('var(')) {
      return acc
    }

    const isColor = value.startsWith('#') || value.startsWith('rgb')

    if (isColor) {
      acc.push({ color: value, path })
    }

    return acc
  }, [])
}
